import type { CookieService } from "@/src/infrastructure/cookieconsent/CookieService";

import { CookieCategory } from "@/src/infrastructure/cookieconsent/CookieCategory";

export const strapiCookie: CookieService<CookieCategory.NECESSARY> = {
  category: CookieCategory.NECESSARY,
  name: "Strapi",
  privacyPolicyUrl: "https://strapi.io/privacy",
  purpose: "Contenus et images",
};
